import { findRateByDate } from "./rate.util";
// Formating service options when creating reservations
// Service Name | Price Amount Currency | Duration min
export var serviceDetailedInfo = function (rates, service, reservationStartTime) {
    var _a, _b;
    var serviceRates = rates === null || rates === void 0 ? void 0 : rates.filter(function (r) { var _a; return (_a = service.rateIds) === null || _a === void 0 ? void 0 : _a.includes(r.id || ''); });
    var selectedRate = findRateByDate(serviceRates, reservationStartTime || new Date());
    var priceAmount = (_a = selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.price) === null || _a === void 0 ? void 0 : _a.amount;
    var priceCurrency = (_b = selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.price) === null || _b === void 0 ? void 0 : _b.currency;
    var parts = [];
    // Add service name
    if (service.name) {
        parts.push(service.name);
    }
    // Add price if available
    if (priceAmount && priceCurrency) {
        parts.push("".concat(priceAmount, " ").concat(priceCurrency));
    }
    // Add duration
    var duration = service.durationMinutes;
    if (duration) {
        parts.push("".concat(duration, " min"));
    }
    return parts.join(' | ');
};
